import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}><path d="M256 93.09V32l-80 81.45 80 81.46v-61.1c66 0 120 54.99 120 122.19 0 20.36-5 39.71-14 57.02l29 29.53c16-25.46 25-55 25-86.55 0-89.6-72-162.91-160-162.91zm0 285.1c-66 0-120-55-120-122.19 0-20.36 5-39.7 14-57.02l-29-29.53C105 193.9 96 224.44 96 256c0 89.6 72 162.91 160 162.91V480l80-81.45-80-81.46v61.1z" /></svg>);